import { isRequiredText, strMax } from '../../../utils';
export const interviewValidate = {
    comment: [strMax(2000, '2000文字以内で入力してください')],
    interviewDate: [isRequiredText('日にちを入力してください')],
    interviewTime: [strMax(100, '100文字以内で入力してください')],
    place: [
        isRequiredText('面談場所を入力してください'),
        strMax(200, '200文字以内で入力してください'),
    ],
};
export default interviewValidate;
